<template>
  <div class="order-wrapper payment-wrapper" :class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <PrimaryFilter
        :searchText="$t('SEARCH')"
        :selectedCategory="selectedCategory"
        :buttonsList="getInvoicesButtons"
        :searchParameters="invoiceSearchParameters"
        :preSearchedParams="searchedParams"
        :enableSearchPopup="enableSearchPopup"
        :menuOptions="$checkMenuOptions(Menu)"
        @searchByParameter="searchByParameter"
        @export="exportInvoice"/>
    </portal>
    <div>
      <div class="flex-container page-filter">
        <div class="flex-item">
          <FilterWrapper
            :values="filterTags"
            @openSliderLeft="openSlideleft = !openSlideleft">
          </FilterWrapper>
        </div>
      </div>
      <div class="slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
        <div class="slideleft_content">
          <div class="content">
            <div class="cardpanel alertoption"
              v-infinite-scroll="loadData"
              infinite-scroll-disabled="loadCheck"
              infinite-scroll-throttle-delay="400"
              infinite-scroll-distance="10">
              <Header :headers = "InvoiceHeader"
                :noCheckbox = "true" />
              <div v-if="isLoading" class="paymentloader"></div>
              <div v-else-if="invoiceList.length === 0" class="emptydiv">
                <div class="paymentempty"></div>
                <div class="emptytext">Enjoy your day, no indents delivered!</div>
                <div class="emptytext txtopacity">गाड़ी नहीं पहुंची क्या ?</div>
              </div>
              <div v-else>
                <Row v-for = "(invoice, index) in invoiceList"
                  :sectionHeader = "InvoiceHeader"
                  :invoice = "invoice"
                  :key = "invoice.id"
                  :index="index"
                  :blockingDueToAgedInvoice = "blockingDueToAgedInvoice"
                  :invoiceAgeWindow = "invoiceAgeWindow"
                  @showDetails = "showDetails"/>
              </div>
            </div>
          </div>
        </div>
        <div class="slideleft_menu">
          <SecFilter
            :selectedFilters="filterConstant"
            :filters="filters"
            :selectedDateFilter="selectedDateFilter"
            @updateOption="updateLegalEntity"
            @updateDateFilter="selectedDateFilter = $event"
            @search="search"
            @reset="resetApply"
             @clearDate="clearDate"/>
        </div>
        <div class="sidenavright" :class="{ isOpen: isOpenUpdate }">
          <Details
            v-if="isOpenUpdate && selectedIndent"
            :invoiceDetail="selectedIndent"
            @close="isOpenUpdate = false" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { uniqBy } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import {
  InvoiceHeader,
  Menu,
  status,
  invoiceFilters,
  gstTypes,
  invoicesButtons,
  invoiceSearchParameters,
  discountStatus,
  filters,
  defaultLEFilter,
  movementTypes } from '@/constants/payments';
import AppConstant from '@/constants/app';
import Header from '@common/components/Header';
import FilterWrapper from '@common/components/FilterWrapperV2';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import downloadFile from '@common/utils/downloadFile';
import Row from '../../pay-v2/invoices/InvoiceRow';
import Details from '../../pay-v2/invoices/Details';

export default {
  components: {
    Header,
    Row,
    SecFilter,
    FilterWrapper,
    PrimaryFilter,
    Details,
  },
  data() {
    return {
      InvoiceHeader,
      openSlideleft: false,
      invoiceFilters,
      invoicesButtons,
      discountStatus,
      enableSearchPopup: true,
      gstTypes,
      movementTypes,
      defaultValues: {},
      Menu,
      status,
      isOpenUpdate: false,
      selectedIndent: null,
      searchedParams: {},
      loadCheck: true,
      filterConstant: [],
      filters,
      hasCustomConstruct: true,
      blockingDueToAgedInvoice: false,
      allDepot: { id: -1, name: 'All' },
      isFreightBill: null,
      defaultLEFilter,
      legalEntityFilters: [],
      pandoLegalEntityFilters: [],
      depots: null,
      approvalFlow: [],
    };
  },
  mixins: [SecFilterMixin],
  computed: {
    ...mapGetters({
      invoiceList: 'paymentsV2/list',
      clients: 'app/clients',
      depotsList: 'app/depots',
      filter: 'paymentsV2/filter',
      hasEmpty: 'paymentsV2/hasEmpty',
      isLoading: 'paymentsV2/isLoading',
      currentClientConfig: 'app/currentClientConfig',
      otherDepots: 'app/getOtherDepots',
    }),
    invoiceSearchParameters() {
      return invoiceSearchParameters.filter(
        param => !param.feature || this.$hasFeature(param.feature),
      );
    },
    customLegalEntityAllowed() {
      return this.$hasFeature('primary_legal_entity');
    },
    isLegalEntityBasedOnBillToParty() {
      return this.$hasFeature('legal_entity_based_on_bill_to_party');
    },
    depotsListData() {
      return this.depotsListData;
    },
    selectedCategory() {
      return this.Menu.find(menu => menu.id === 'invoices');
    },
    invoiceAgeWindow() {
      return (this.currentClientConfig && this.currentClientConfig.payment_settings
        && this.currentClientConfig.payment_settings.max_age_invoice) || 0;
    },
    filteredInvoiceStatusList() {
      this.status = this.status.filter(statusValue => statusValue.name !== 'All Statuses');
      if (this.$hasFeature('custom_invoice_approval')) {
        this.status.push({ id: 11, groupId: 11, name: 'Custom', color: 'blue' });
      }
      return this.isFreightBill ? this.status : this.status.filter(statusValue => statusValue.name !== 'Cancelled');
    },
    datePickerOptions() {
      return [
        {
          displayLabel: this.filters.CREATION_DATE,
          paramKey: 'creation',
        },
        {
          displayLabel: this.filters.UPDATION_DATE,
          paramKey: 'updated',
        },
      ];
    },
    showLegalEntity() {
      return (this.currentClientConfig && this.currentClientConfig.legal_entity_level === 'GATE') || this.$hasFeature('show_legal_entity_filter');
    },
    getInvoicesButtons(){
      return this.invoicesButtons.map((button) => {
        if (button.name === 'Export') {
          return { ...button, disabled: this.invoiceList.length === 0 };
        }
        return button;
      });
    }
  },
  watch: {
    selectedDateFilter(newValue) {
      const datePickerFilter = this.filterConstant[1] && this.filterConstant[1].find(filter => filter.type === 'DatePicker');
      if (datePickerFilter) {
        if (newValue === 'updated') {
          datePickerFilter.startDate = this.defaultValues.updationStartDate;
        } else {
          datePickerFilter.startDate = this.defaultValues.startDate;
        }
      }
    },
  },
  async created() {
    this.updateStatusWithCustomStatuses();

    this.$store.commit('paymentsV2/initialReset');
    const allowedInvoiceFilters = this.invoiceFilters.filter(_filter =>
      (_filter.age_filter ? !!this.invoiceAgeWindow : true),
    );
    this.isFreightBill = this.currentClientConfig && this.currentClientConfig.freight_bill
      && this.currentClientConfig.freight_bill.is_enabled;
    this.invoiceFilters = allowedInvoiceFilters;
    this.setDefaults();
    this.loadFilters();
    this.loadSearchFromSession();
    this.search();
    if (this.$hasFeature('custom_invoice_approval')) {
      const result = await this.$store.dispatch(
        'paymentsV2/getInvoiceApprovalSettings',
      );
      this.allMovementSettings = result || [];
      this.setCustomStatusFilter();
    }
  },
  methods: {
    getLegalEntity(item) {
      if (this.customLegalEntityAllowed) {
        return {
          id: `lec-${item.client_legal_entity}`,
          name: item.client_legal_entity,
          value: item.client_legal_entity,
        };
      }
      return item;
    },
    handleRegularLegalEntityFilter(depot) {
      let legalEntity = [];
      if (depot.legal_entity && depot.legal_entity.length) {
        const temp = [];
        legalEntity = depot.legal_entity.reduce((acc, _entity) => {
          const entity = this.getLegalEntity(_entity);
          if (!temp.includes(entity.name)) {
            acc.push(entity);
            temp.push(entity.name);
          }
          return acc;
        }, []);
      }
      this.legalEntityFilters = legalEntity && legalEntity.length
        ? this.defaultLEFilter.concat(legalEntity) : this.defaultLEFilter;
      this.setLegalEntityFilter();
      this.setPandoLegalEntityFilter();
    },
    handleBillToPartyLegalEntityFilter(billToPartyDepot) {
      let legalEntity = [];
      if (billToPartyDepot && billToPartyDepot.legal_entity && billToPartyDepot.legal_entity.length) {
        const temp = [];
        legalEntity = billToPartyDepot.legal_entity.reduce((acc, _entity) => {
          const entity = this.getLegalEntity(_entity);
          if (!temp.includes(entity.name)) {
            acc.push(entity);
            temp.push(entity.name);
          }
          return acc;
        }, []);
      }
      this.legalEntityFilters = legalEntity && legalEntity.length
        ? this.defaultLEFilter.concat(legalEntity) : this.defaultLEFilter;
      this.setLegalEntityFilter();
      this.setPandoLegalEntityFilter();
    },
    updateLegalEntity(index1, index2, data, type = null) {
      if (this.filterConstant[index1][index2].category === this.filters.DEPOT) {
        if (!this.isLegalEntityBasedOnBillToParty) {
          this.handleRegularLegalEntityFilter(data);
        }
      } else if (this.filterConstant[index1][index2].category === this.filters.BILL_TO_PARTY) {
        if (this.isLegalEntityBasedOnBillToParty) {
          this.handleBillToPartyLegalEntityFilter(data);
        }
      } else if (this.filterConstant[index1][index2].category === this.filters.LEGAL_ENTITY) {
        this.setPandoLegalEntityFilter(data);
      }
      this.filterConstant = [...this.filterConstant];
      this.updateOption(index1, index2, data, type);
    },
    setPandoLegalEntityFilter(selectedClientLe = null) {
      if (this.customLegalEntityAllowed) {
        const result = {
          list: this.defaultLEFilter,
          default: this.defaultLEFilter[0],
          selected: this.defaultLEFilter[0],
        };
        const index = this.filterConstant[0].findIndex(filter =>
          filter.category === this.filters.PANDO_LEGAL_ENTITY);
        if (selectedClientLe && selectedClientLe.id !== -1) {
          let selectedSource = null;
          if (this.isLegalEntityBasedOnBillToParty) {
            const billToPartyFilter = this.filterConstant[this.isLegalEntityBasedOnBillToParty ? 0 : 1]
              .find(item => item.category === this.filters.BILL_TO_PARTY);
            selectedSource = (billToPartyFilter && billToPartyFilter.selected) || null;
          } else {
            const depotFilter = this.filterConstant[0]
              .find(item => item.category === this.filters.DEPOT);
            selectedSource = (depotFilter && depotFilter.selected) || null;
          }
          result.list = result.list.concat(
            (selectedSource && selectedSource.client_le_to_pando_le_map
              && selectedSource.client_le_to_pando_le_map[selectedClientLe.value])
            || [],
          );
        }
        this.pandoLegalEntityFilters = uniqBy(result.list, 'name');
        this.filterConstant[0][index].list = this.pandoLegalEntityFilters;
        this.filterConstant[0][index].default = this.pandoLegalEntityFilters[0];
        this.filterConstant[0][index].selected = this.pandoLegalEntityFilters[0];
      }
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    checkMenuOptions() {
      return this.Menu.filter(element =>
        (element.feature ? this.$hasFeature(element.feature) : true) &&
        (element.permission ? this.$hasPermission(element.permission) : true),
      );
    },
    setDefaults() {
      const depot = this.$route.query.depot;
      const depotObj = this.depotsList && (this.depotsList.find(value => value.name === depot)
        || this.otherDepots.find(value => value.name === depot)
        || this.depotsList[0] || this.otherDepots[0]);
      if (this.isLegalEntityBasedOnBillToParty) {
        this.legalEntityFilters = this.defaultLEFilter;
      } else {
        const legalEntityFilter = depotObj.legal_entity ? depotObj.legal_entity.map(item => this.getLegalEntity(item)) : [];
        this.legalEntityFilters = depotObj.legal_entity ? this.defaultLEFilter.concat(legalEntityFilter) : this.defaultLEFilter;
      }
      this.pandoLegalEntityFilters = this.defaultLEFilter;
      this.defaultValues.depots = this.isFreightBill ? this.allDepot : depotObj;
      [this.defaultValues.client] = this.clients;
      [this.defaultValues.invoiceType] = this.invoiceFilters;
      [this.defaultValues.gstType] = this.gstTypes;
      this.defaultValues.movementType = this.movementTypes.filter(m => m.id !== -1);
      this.defaultValues.status = this.filteredInvoiceStatusList;
      [this.defaultValues.discountStatus] = this.discountStatus;
      this.defaultValues.endDate = moment().toString();
      this.defaultValues.startDate = moment().subtract(120, 'days').toString();
      this.defaultValues.updationStartDate = moment().subtract(45, 'days').toString();
      [this.defaultValues.legalEntity] = this.legalEntityFilters;
      [this.defaultValues.pandoLegalEntity] = this.pandoLegalEntityFilters;
    },
    constructDepotListPay(billToPartyDepot = false) {
      const group = [];
      if (this.isFreightBill) {
        group.push(
          {
            group_type: AppConstant.DepotGroupType.ALL_DEPOT,
            options: [{ id: -1, name: 'All' }],
            icon: null,
          });
      }
      if (this.depotsList.length) {
        group.push(
          {
            group_type: billToPartyDepot ? AppConstant.DepotGroupType.BILL_TO_PARTY_DEPOT :
              AppConstant.DepotGroupType.ASSOCIATED_DEPOT,
            options: this.depotsList,
            icon: null,
          },
        );
      }
      if (this.otherDepots.length) {
        group.push({
          group_type: AppConstant.DepotGroupType.OTHER_DEPOT,
          options: this.otherDepots,
          icon: null,
        });
      }
      return group;
    },
    constructConstantForFilter() {
      this.depots = this.depotsList;
      this.filterConstant = [
        [
          {
            type: 'List',
            category: this.filters.CLIENT,
            default: this.defaultValues.client,
            selected: this.defaultValues.client,
            list: this.clients,
            queryParamString: 'client_id',
            idLabel: 'id',
            optional: false,
            tlabel: 'INVOICE_CLIENT',
          },
          {
            type: 'GroupList',
            category: this.filters.DEPOT,
            default: this.defaultValues.depots,
            selected: this.defaultValues.depots,
            list: this.constructDepotListPay(),
            queryParamString: 'depot_id',
            idLabel: 'id',
            optional: false,
            search: true,
            tlabel: 'INVOICE_DEPOT',
            searchEnable: true,
          },
          {
            type: 'MultiSelectList',
            category: this.filters.MOVEMENT,
            default: this.defaultValues.movementType,
            selected: this.defaultValues.movementType,
            list: this.movementTypes.filter(m => m.id !== -1),
            idLabel: 'id',
            optional: false,
            selectAllOption: true,
            defaultSelectAll: true,
            queryParamString: 'movement_type',
            placeholder: 'Select Movement Type',
            tlabel: 'MDM_MOVEMENT_TYPE',
          },
          ...(this.isLegalEntityBasedOnBillToParty && this.$hasFeature('bill_to_party_filter_in_invoice_flow') ? [{
            type: 'GroupList',
            category: this.filters.BILL_TO_PARTY,
            default: [],
            selected: [],
            list: this.constructDepotListPay(true),
            queryParamString: 'bill_to_party',
            idLabel: 'id',
            optional: false,
            search: true,
            tlabel: 'PAY_BILL_TO_PARTY',
            searchEnable: true,
          }] : []),
          {
            type: 'List',
            category: this.filters.LEGAL_ENTITY,
            default: this.defaultValues.legalEntity,
            selected: this.defaultValues.legalEntity,
            list: this.legalEntityFilters,
            queryParamString: this.customLegalEntityAllowed ? 'client_legal_entity' : 'legal_entity',
            idLabel: 'value',
            optional: true,
            search: true,
            hasPermission: this.showLegalEntity,
            tlabel: 'INVOICE_LEGAL_ENTITY',
          },
          {
            type: 'List',
            category: this.filters.PANDO_LEGAL_ENTITY,
            default: this.defaultValues.pandoLegalEntity,
            selected: this.defaultValues.pandoLegalEntity,
            list: this.pandoLegalEntityFilters,
            queryParamString: 'legal_entity',
            idLabel: 'value',
            optional: true,
            search: true,
            hasPermission: this.showLegalEntity && this.customLegalEntityAllowed,
            tlabel: 'PANDO_LEGAL_ENTITY',
          },
        ],
        [
          ...(!this.isLegalEntityBasedOnBillToParty && this.$hasFeature('bill_to_party_filter_in_invoice_flow') ? [{
            type: 'GroupList',
            category: this.filters.BILL_TO_PARTY,
            default: [],
            selected: [],
            list: this.constructDepotListPay(true),
            queryParamString: 'bill_to_party',
            idLabel: 'id',
            optional: false,
            search: true,
            tlabel: 'PAY_BILL_TO_PARTY',
            searchEnable: true,
          }] : []),
          {
            type: 'DatePicker',
            category: this.filters.DATE_PICKER,
            tlabel: 'INVOICE_DATE',
            radioOptions: this.datePickerOptions,
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            start_date_label: 'start',
            end_date_label: 'end',
            optional: true,
            dateType: null,
            updationStartDate: this.defaultValues.updationStartDate,
          },
          {
            type: 'MultiSelectList',
            category: filters.STATUS,
            default: this.defaultValues.status,
            selected: this.defaultValues.status,
            list: this.filteredInvoiceStatusList,
            queryParamString: 'status_group',
            selectAllOption: true,
            defaultSelectAll: true,
            idLabel: 'groupId',
            optional: false,
            tlabel: 'INVOICE_STATUS',
          },
          {
            type: 'List',
            category: filters.GST_TYPE,
            default: this.defaultValues.gstType,
            selected: this.defaultValues.gstType,
            list: this.gstTypes,
            queryParamString: 'gst_type',
            idLabel: 'id',
            optional: true,
            tlabel: 'INVOICE_GST_TYPE',
          },
          {
            type: 'List',
            category: filters.INVOICE_TYPE,
            default: this.defaultValues.invoiceType,
            selected: this.defaultValues.invoiceType,
            list: this.invoiceFilters,
            queryParamString: 'invoice_type',
            idLabel: 'id',
            optional: true,
            tlabel: 'INVOICE_TYPE',
          },
          {
            type: 'List',
            category: filters.DISCOUNT_STATUS,
            default: this.defaultValues.discountStatus,
            selected: this.defaultValues.discountStatus,
            list: this.discountStatus,
            queryParamString: 'discount_status',
            idLabel: 'id',
            optional: true,
            tlabel: 'INVOICE_DISCOUNT_STATUS',
          },
        ],
      ];
    },
    setCustomStatusFilter() {
      let customStatus = this.allMovementSettings.reduce((acc, settings) => {
        const approvalFlow = settings.invoice_approval_flow || [];
        approvalFlow.forEach((item) => {
          if (!['Generated', 'Approved'].includes(item.status_name)) {
            acc.push({
              name: item.status_name,
              id: item.status_name,
            });
          }
          return acc;
        });
        return acc;
      }, []);
      customStatus = uniqBy(customStatus, 'name');
      const isCustomInvoiceFilterExists = this.filterConstant[1].find(item =>
        item.category === filters.CUSTOM_STATUS);
      if (!isCustomInvoiceFilterExists) {
        this.filterConstant[1].push({
          type: 'MultiSelectList',
          category: filters.CUSTOM_STATUS,
          default: [],
          selected: [],
          list: customStatus,
          idLabel: 'name',
          optional: false,
          selectAllOption: true,
          defaultSelectAll: false,
          queryParamString: 'custom_status',
          placeholder: 'Select status',
          tlabel: 'CUSTOM_INVOICE_STATUS',
          allowEmpty: true,
          preSelectFirst: false,
        });
      }
    },
    customConstructFilter() {
      this.filterConstant[0][1].list = this.constructDepotListPay();
    },
    resetApply() {
      const depotIndex = this.filterConstant[0].findIndex(filter =>
        filter.category === this.filters.DEPOT);
      const legalEntity = this.filterConstant[0][depotIndex] && this.filterConstant[0][depotIndex].list[0] &&
        this.filterConstant[0][depotIndex].list[0].legal_entity;
      this.legalEntityFilters = legalEntity ? this.defaultLEFilter.concat(legalEntity) : this.defaultLEFilter;
      this.$store.commit('paymentsV2/setPage', 1);
      this.setLegalEntityFilter();
      this.resetAll();
      this.search();
    },
    setLegalEntityFilter() {
      const index = this.filterConstant[0].findIndex(filter =>
        filter.category === this.filters.LEGAL_ENTITY);
      this.filterConstant[0][index].list = this.legalEntityFilters;
      this.filterConstant[0][index].default = this.legalEntityFilters[0];
      this.filterConstant[0][index].selected = this.legalEntityFilters[0];
    },
    search() {
      this.$store.commit('paymentsV2/setPage', 1);
      this.applyFilters();
      this.openSlideleft = false;
      this.loadData();
    },
    searchByParameter(query) {
      this.searchedParams = query;
      this.$store.commit('paymentsV2/setPage', 1);
      this.saveSearchToSession();
      this.loadData();
    },

    updateStatusWithCustomStatuses() {
      const statusHash = {};
      this.status.forEach((_status) => {
        statusHash[_status.id] = true;
      });
      if (
        this.currentClientConfig &&
        this.currentClientConfig.erp_payment_configuration &&
        this.currentClientConfig.erp_payment_configuration.custom_status
      ) {
        this.currentClientConfig.erp_payment_configuration.custom_status.forEach((customStatus) => {
          if (!statusHash[customStatus.status_code]) {
            this.status.push({
              id: customStatus.status_code,
              name: customStatus.status_name,
              ids: [customStatus.status_code],
              groupId: customStatus.status_code,
              color: 'midnightexpress',
            });
          }
        });
      }
    },
    async loadData() {
      try {
        if (this.clients.length > 0 && (this.depotsList.length > 0 || this.otherDepots.length)) {
          let filter = this.constructFilterPayload();
          if (filter) {
            filter = Object.assign(filter, this.filter);
            if (this.searchedParams && Object.keys(this.searchedParams).length) {
              Object.assign(filter, { ...this.searchedParams });
            }
            const result = await this.$store.dispatch('paymentsV2/filterInvoice', filter);
            this.blockingDueToAgedInvoice = result.blockingDueToAgedInvoice;
            if (result.error) {
              this.$errorMessage({ message: result.error });
              return
            }
            this.loadCheck = this.hasEmpty;
          }
        } else {
          this.$errorMessage({ message: this.$getErr('FEILDS_MISSING') });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    async showDetails(index) {
      try {
        const invoice = this.invoiceList[index];
        const result = await this.$store.dispatch('paymentsV2/invoiceDetails', { invoiceId: invoice.id });
        if (result && result.error) {
          this.$errorMessage({ message: result.error });
        } else if (result && result.data) {
          this.selectedIndent = result.data;
          this.isOpenUpdate = true;
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    async exportInvoice() {
      try {
        const filter = this.constructFilterPayload();
        if (filter) {
          if (this.searchedParams && Object.keys(this.searchedParams).length) {
            Object.assign(filter, { ...this.searchedParams });
          }
          const result = await this.$store.dispatch('paymentsV2/invoiceExport', filter);
          if (result.type === 'application/json') {
            this.$infoMessage({ message: this.$getSuccess('EXPORT_VIA_EMAIL') });
          } else {
            const url = window.URL.createObjectURL(new Blob([result]));
            const now = new Date().toISOString();
            downloadFile(document, url, `Invoice-${now}.xlsx`);
          }
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('EXPORT_FAILS') });
      }
    },
  },
};
</script>
